import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.TextColumn("Nombre", "nombre"),
    ColumnsFactory.TextColumn("Email", "email"),
    ColumnsFactory.TextColumn("Cod.DN/SG", "idDN"),
    ColumnsFactory.TextColumn("DN/SG", "direccionNegocio"),
    ColumnsFactory.NumericColumn("Año", "año"),
    ColumnsFactory.NumericColumn("Mes", "mes"),
    ColumnsFactory.DecimalColumn("Horas Mes", "horasMes"),
    ColumnsFactory.DecimalColumn("Horas Estimadas", "horasEstimadas"),
    ColumnsFactory.DecimalColumn("% Dedicación Terceros", "dedicacionTerceros", {ipkTotalizar:false}),
  ];
};